document.addEventListener("DOMContentLoaded", function() {
  // Fonction pour formater la date en DD/MM/YYYY
  function formatDate(date) {
      let day = date.getDate();
      let month = date.getMonth() + 1; // Les mois commencent à 0
      let year = date.getFullYear();
      
      // Ajouter un zéro devant les jours et mois inférieurs à 10
      if(day < 10) {
          day = '0' + day;
      }
      if(month < 10) {
          month = '0' + month;
      }
      return day + '/' + month + '/' + year;
  }

  // Fonction pour calculer et afficher les dates
  function calculateAndDisplayDates() {
      let currentDate = new Date();

      let firstDateElement = document.getElementById('first_date');
      let firstDateOffset = parseInt(firstDateElement.getAttribute('data-firstdate'), 10);
      let firstDate = new Date(currentDate);
      firstDate.setDate(currentDate.getDate() + firstDateOffset);
      firstDateElement.innerText = formatDate(firstDate);

      let lastDateElement = document.getElementById('last_date');
      let lastDateOffset = parseInt(lastDateElement.getAttribute('data-lastdate'), 10);
      let lastDate = new Date(currentDate);
      lastDate.setDate(currentDate.getDate() + lastDateOffset);
      lastDateElement.innerText = formatDate(lastDate);
  }

  // Appeler la fonction pour calculer et afficher les dates
  calculateAndDisplayDates();
});